// @generated by protoc-gen-es v2.14.1 with parameter "target=ts"
// @generated from file fertilizacion.proto (package sextante.fertilizacion.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file fertilizacion.proto.
 */
export const file_fertilizacion: GenFile = /*@__PURE__*/
  fileDesc("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");

/**
 * Valor de un parametro del analisis, como pH o potasio, con su clasificacion agronomica.
 *
 * @generated from message sextante.fertilizacion.v1.AnalisisParametroItem
 */
export type AnalisisParametroItem = Message<"sextante.fertilizacion.v1.AnalisisParametroItem"> & {
  /**
   * Nombre canonico del parametro, como ph, total_nitrogen o potassium. Es la clave que usa
   * AnalisisNutrienteItem.source_parameter.
   *
   * @generated from field: string nombre = 1;
   */
  nombre: string;

  /**
   * Valor numerico. Ausente si no se pudo extraer.
   *
   * @generated from field: optional double valor = 2;
   */
  valor?: number | undefined;

  /**
   * Unidad normalizada, como %, ppm o meq/100g. Mostrar siempre la que llega.
   *
   * @generated from field: string unidad = 3;
   */
  unidad: string;

  /**
   * Clasificacion del valor, como optimal, low, high, deficient o toxic. Tambien categorical, sentinel,
   * no_data y no_range, que se muestran en gris.
   *
   * @generated from field: optional string estado = 4;
   */
  estado?: string | undefined;

  /**
   * Color hexadecimal sugerido para el semaforo.
   *
   * @generated from field: optional string color = 5;
   */
  color?: string | undefined;

  /**
   * true si el laboratorio no analizo este parametro: se muestra N/A.
   *
   * @generated from field: bool is_sentinel = 6;
   */
  isSentinel: boolean;

  /**
   * true si el valor es texto, como la textura del suelo.
   *
   * @generated from field: bool is_categorical = 7;
   */
  isCategorical: boolean;

  /**
   * Valor en texto cuando is_categorical es true.
   *
   * @generated from field: optional string text_value = 8;
   */
  textValue?: string | undefined;

  /**
   * Rango optimo ya formateado y sin unidad, como 5.5 - 6.5 o < 20. Ausente si no hay rango.
   *
   * @generated from field: optional string rango_texto = 9;
   */
  rangoTexto?: string | undefined;
};

/**
 * Describes the message sextante.fertilizacion.v1.AnalisisParametroItem.
 * Use `create(AnalisisParametroItemSchema)` to create a new message.
 */
export const AnalisisParametroItemSchema: GenMessage<AnalisisParametroItem> = /*@__PURE__*/
  messageDesc(file_fertilizacion, 0);

/**
 * Nutriente recomendado para un registro, en oxido equivalente. Lo genera el microservicio de recomendacion.
 *
 * @generated from message sextante.fertilizacion.v1.AnalisisNutrienteItem
 */
export type AnalisisNutrienteItem = Message<"sextante.fertilizacion.v1.AnalisisNutrienteItem"> & {
  /**
   * Nutriente en oxido: N, P2O5, K2O, CaO, MgO, SO3, Zn, Cu, B, Fe, Mn o MO.
   *
   * @generated from field: string nutrient = 1;
   */
  nutrient: string;

  /**
   * chemical, organic_amendment o liming. La lista de compra Nitrofert solo cubre los chemical.
   *
   * @generated from field: string nutrient_type = 2;
   */
  nutrientType: string;

  /**
   * Dosis neta por hectarea, ya descontado lo que aporta el encalado.
   *
   * @generated from field: double kg_ha = 3;
   */
  kgHa: number;

  /**
   * Dosis total: kg_ha por el area del lote.
   *
   * @generated from field: double kg_total = 4;
   */
  kgTotal: number;

  /**
   * Nivel: 0 estructural, 1 encalado, 2 macros, 3 secundarios, 4 micros.
   *
   * @generated from field: int32 tier = 5;
   */
  tier: number;

  /**
   * immediate, this_season o next_season.
   *
   * @generated from field: string urgency = 6;
   */
  urgency: string;

  /**
   * Nota agronomica del nutriente.
   *
   * @generated from field: optional string note = 7;
   */
  note?: string | undefined;

  /**
   * Presente si una condicion del suelo, como pH critico o aluminio toxico, reduce la absorcion. La
   * recomendacion se entrega igual.
   *
   * @generated from field: optional string efficiency_warning = 8;
   */
  efficiencyWarning?: string | undefined;

  /**
   * Absorcion esperada, en porcentaje, si no se corrige esa condicion.
   *
   * @generated from field: optional int32 estimated_efficiency_pct = 9;
   */
  estimatedEfficiencyPct?: number | undefined;

  /**
   * Parametro que disparo el nutriente. Con nutrient_type y tier distingue oxidos con varios origenes, como
   * CaO de encalado o de calcio.
   *
   * @generated from field: optional string source_parameter = 10;
   */
  sourceParameter?: string | undefined;

  /**
   * Todos los parametros que disparo el nutriente. Un parametro esta cubierto por otro cuando aparece aca sin
   * ser source_parameter.
   *
   * @generated from field: repeated string source_parameters = 11;
   */
  sourceParameters: string[];
};

/**
 * Describes the message sextante.fertilizacion.v1.AnalisisNutrienteItem.
 * Use `create(AnalisisNutrienteItemSchema)` to create a new message.
 */
export const AnalisisNutrienteItemSchema: GenMessage<AnalisisNutrienteItem> = /*@__PURE__*/
  messageDesc(file_fertilizacion, 1);

/**
 * Registro del analisis: un lote o muestra del Excel, con el lote del sistema que se le asocio, el cultivo y
 * sus parametros.
 *
 * @generated from message sextante.fertilizacion.v1.AnalisisRegistroItem
 */
export type AnalisisRegistroItem = Message<"sextante.fertilizacion.v1.AnalisisRegistroItem"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Lote del sistema asociado por nombre o a mano. Ausente si falta asignarlo.
   *
   * @generated from field: optional string lote_id = 2;
   */
  loteId?: string | undefined;

  /**
   * Resolucion del cultivo hecha por Lab Parser API: resolved, ambiguous o unresolved.
   *
   * @generated from field: string crop_resolution_status = 3;
   */
  cropResolutionStatus: string;

  /**
   * Cultivo tal como aparece en el Excel.
   *
   * @generated from field: optional string crop_raw = 4;
   */
  cropRaw?: string | undefined;

  /**
   * Clave del cultivo resuelto, como platano.
   *
   * @generated from field: optional string crop = 5;
   */
  crop?: string | undefined;

  /**
   * Id de la muestra asignado por el laboratorio.
   *
   * @generated from field: string id_muestra = 6;
   */
  idMuestra: string;

  /**
   * Nombre del lote tal como aparece en el Excel.
   *
   * @generated from field: string lote_excel = 7;
   */
  loteExcel: string;

  /**
   * Alertas agronomicas, como pH critico.
   *
   * @generated from field: repeated string alertas = 8;
   */
  alertas: string[];

  /**
   * @generated from field: repeated sextante.fertilizacion.v1.AnalisisParametroItem parametros = 9;
   */
  parametros: AnalisisParametroItem[];

  /**
   * Grupo de lotes con plan compartido. Solo Nitrofert, y solo despues de recomendar.
   *
   * @generated from field: optional string grupo_id = 10;
   */
  grupoId?: string | undefined;

  /**
   * true si es el lote de referencia de su grupo, cuyo plan se aplica a todos.
   *
   * @generated from field: bool es_referencia = 11;
   */
  esReferencia: boolean;

  /**
   * Severidad del lote: critical, deficient o maintenance. Ausente antes de recomendar.
   *
   * @generated from field: optional string severity_level = 12;
   */
  severityLevel?: string | undefined;

  /**
   * Motivos de la severidad.
   *
   * @generated from field: repeated string severity_reasons = 13;
   */
  severityReasons: string[];

  /**
   * Resumen del plan en lenguaje natural, para el tecnico.
   *
   * @generated from field: optional string plan_summary = 14;
   */
  planSummary?: string | undefined;

  /**
   * Area del lote usada al recomendar, en hectareas.
   *
   * @generated from field: optional double plan_area_ha = 15;
   */
  planAreaHa?: number | undefined;

  /**
   * Nutrientes recomendados. Vacio si es mantenimiento o si todavia no se recomendo.
   *
   * @generated from field: repeated sextante.fertilizacion.v1.AnalisisNutrienteItem nutrientes = 16;
   */
  nutrientes: AnalisisNutrienteItem[];
};

/**
 * Describes the message sextante.fertilizacion.v1.AnalisisRegistroItem.
 * Use `create(AnalisisRegistroItemSchema)` to create a new message.
 */
export const AnalisisRegistroItemSchema: GenMessage<AnalisisRegistroItem> = /*@__PURE__*/
  messageDesc(file_fertilizacion, 2);

/**
 * Grupo de lotes que comparten plan de fertilizacion. Solo Nitrofert.
 *
 * @generated from message sextante.fertilizacion.v1.AnalisisGrupoItem
 */
export type AnalisisGrupoItem = Message<"sextante.fertilizacion.v1.AnalisisGrupoItem"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Area de todos los lotes del grupo, en hectareas.
   *
   * @generated from field: double total_area_ha = 2;
   */
  totalAreaHa: number;

  /**
   * JSON crudo, ver comentario de arriba
   *
   * @generated from field: optional string nitrofert_plan = 3;
   */
  nitrofertPlan?: string | undefined;

  /**
   * Error del microservicio que arma el plan comercial, si fallo.
   *
   * @generated from field: optional string l3_error = 4;
   */
  l3Error?: string | undefined;
};

/**
 * Describes the message sextante.fertilizacion.v1.AnalisisGrupoItem.
 * Use `create(AnalisisGrupoItemSchema)` to create a new message.
 */
export const AnalisisGrupoItemSchema: GenMessage<AnalisisGrupoItem> = /*@__PURE__*/
  messageDesc(file_fertilizacion, 3);

/**
 * Producto de la lista de compra de la finca. Solo Nitrofert. La cal y la materia organica no aparecen aca:
 * van en los nutrientes de cada registro.
 *
 * @generated from message sextante.fertilizacion.v1.AnalisisCompraItem
 */
export type AnalisisCompraItem = Message<"sextante.fertilizacion.v1.AnalisisCompraItem"> & {
  /**
   * Producto comercial, como Nitrofert 15-15-15.
   *
   * @generated from field: string product = 1;
   */
  product: string;

  /**
   * Linea del producto, como granulado.
   *
   * @generated from field: optional string line = 2;
   */
  line?: string | undefined;

  /**
   * true si el producto es libre de cloro.
   *
   * @generated from field: bool cl_free = 3;
   */
  clFree: boolean;

  /**
   * Kilos del producto para toda la finca.
   *
   * @generated from field: double kg_total = 4;
   */
  kgTotal: number;

  /**
   * Bultos de 50 kg, redondeado hacia arriba.
   *
   * @generated from field: int32 bags_50_kg = 5;
   */
  bags50Kg: number;

  /**
   * Nombres de los lotes que usan el producto, tal como los devuelve el microservicio.
   *
   * @generated from field: repeated string lots = 6;
   */
  lots: string[];

  /**
   * Ids de esos lotes en el sistema. Puede tener menos elementos que lots.
   *
   * @generated from field: repeated string lote_ids = 7;
   */
  loteIds: string[];

  /**
   * Area de los lotes de lote_ids, en hectareas.
   *
   * @generated from field: double area_consumida_ha = 8;
   */
  areaConsumidaHa: number;
};

/**
 * Describes the message sextante.fertilizacion.v1.AnalisisCompraItem.
 * Use `create(AnalisisCompraItemSchema)` to create a new message.
 */
export const AnalisisCompraItemSchema: GenMessage<AnalisisCompraItem> = /*@__PURE__*/
  messageDesc(file_fertilizacion, 4);

/**
 * Analisis de laboratorio de una finca, con sus registros y, si ya se recomendo, el plan.
 *
 * @generated from message sextante.fertilizacion.v1.AnalisisLaboratorioItem
 */
export type AnalisisLaboratorioItem = Message<"sextante.fertilizacion.v1.AnalisisLaboratorioItem"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * true si el registro se dio de baja: la app lo quita de su base local.
   *
   * @generated from field: bool eliminado = 2;
   */
  eliminado: boolean;

  /**
   * Ultimo cambio del registro, en Unix ms.
   *
   * @generated from field: int64 ultima_actualizacion = 3;
   */
  ultimaActualizacion: bigint;

  /**
   * @generated from field: string finca_id = 4;
   */
  fincaId: string;

  /**
   * Fecha del analisis, yyyy-MM-dd.
   *
   * @generated from field: string fecha_analisis = 5;
   */
  fechaAnalisis: string;

  /**
   * @generated from field: string nombre_archivo = 6;
   */
  nombreArchivo: string;

  /**
   * @generated from field: int32 total_registros = 7;
   */
  totalRegistros: number;

  /**
   * soil para suelo o foliar.
   *
   * @generated from field: string tipo_analisis = 8;
   */
  tipoAnalisis: string;

  /**
   * Perfil de laboratorio que detecto Lab Parser API.
   *
   * @generated from field: string nombre_laboratorio = 9;
   */
  nombreLaboratorio: string;

  /**
   * Registros que todavia no tienen lote o cultivo resuelto.
   *
   * @generated from field: int32 pending_lots_count = 10;
   */
  pendingLotsCount: number;

  /**
   * Ultima vez que se genero la recomendacion, en Unix ms. Ausente si nunca se genero.
   *
   * @generated from field: optional int64 recomendacion_fecha = 11;
   */
  recomendacionFecha?: bigint | undefined;

  /**
   * @generated from field: repeated sextante.fertilizacion.v1.AnalisisRegistroItem registros = 12;
   */
  registros: AnalisisRegistroItem[];

  /**
   * @generated from field: repeated sextante.fertilizacion.v1.AnalisisGrupoItem grupos = 13;
   */
  grupos: AnalisisGrupoItem[];

  /**
   * @generated from field: repeated sextante.fertilizacion.v1.AnalisisCompraItem compra = 14;
   */
  compra: AnalisisCompraItem[];
};

/**
 * Describes the message sextante.fertilizacion.v1.AnalisisLaboratorioItem.
 * Use `create(AnalisisLaboratorioItemSchema)` to create a new message.
 */
export const AnalisisLaboratorioItemSchema: GenMessage<AnalisisLaboratorioItem> = /*@__PURE__*/
  messageDesc(file_fertilizacion, 5);

/**
 * Pedido de los analisis de una finca.
 *
 * @generated from message sextante.fertilizacion.v1.ListAnalisisByFincaIdRequest
 */
export type ListAnalisisByFincaIdRequest = Message<"sextante.fertilizacion.v1.ListAnalisisByFincaIdRequest"> & {
  /**
   * @generated from field: string finca_id = 1;
   */
  fincaId: string;

  /**
   * Delta: ultima sincronizacion en Unix ms, el timestamp_sincronizacion de la respuesta anterior. Con 0 trae
   * todo.
   *
   * @generated from field: int64 ultima_sincronizacion = 2;
   */
  ultimaSincronizacion: bigint;
};

/**
 * Describes the message sextante.fertilizacion.v1.ListAnalisisByFincaIdRequest.
 * Use `create(ListAnalisisByFincaIdRequestSchema)` to create a new message.
 */
export const ListAnalisisByFincaIdRequestSchema: GenMessage<ListAnalisisByFincaIdRequest> = /*@__PURE__*/
  messageDesc(file_fertilizacion, 6);

/**
 * Analisis que cambiaron desde la ultima sincronizacion.
 *
 * @generated from message sextante.fertilizacion.v1.ListAnalisisByFincaIdResponse
 */
export type ListAnalisisByFincaIdResponse = Message<"sextante.fertilizacion.v1.ListAnalisisByFincaIdResponse"> & {
  /**
   * @generated from field: repeated sextante.fertilizacion.v1.AnalisisLaboratorioItem items = 1;
   */
  items: AnalisisLaboratorioItem[];

  /**
   * Hora del servidor en Unix ms, tomada antes de consultar. La app la guarda y la manda como
   * ultima_sincronizacion en el proximo pedido.
   *
   * @generated from field: int64 timestamp_sincronizacion = 2;
   */
  timestampSincronizacion: bigint;
};

/**
 * Describes the message sextante.fertilizacion.v1.ListAnalisisByFincaIdResponse.
 * Use `create(ListAnalisisByFincaIdResponseSchema)` to create a new message.
 */
export const ListAnalisisByFincaIdResponseSchema: GenMessage<ListAnalisisByFincaIdResponse> = /*@__PURE__*/
  messageDesc(file_fertilizacion, 7);

/**
 * Igual que REST: blob_url apunta al Excel ya subido a Storage por el cliente (el server lo
 * descarga y lo manda al microservicio externo). Solo creacion, no hay update.
 *
 * @generated from message sextante.fertilizacion.v1.ParsearAnalisisRequest
 */
export type ParsearAnalisisRequest = Message<"sextante.fertilizacion.v1.ParsearAnalisisRequest"> & {
  /**
   * @generated from field: string finca_id = 1;
   */
  fincaId: string;

  /**
   * URL del Excel ya subido a Storage.
   *
   * @generated from field: string blob_url = 2;
   */
  blobUrl: string;

  /**
   * Fecha del analisis, yyyy-MM-dd.
   *
   * @generated from field: string fecha_analisis = 3;
   */
  fechaAnalisis: string;
};

/**
 * Describes the message sextante.fertilizacion.v1.ParsearAnalisisRequest.
 * Use `create(ParsearAnalisisRequestSchema)` to create a new message.
 */
export const ParsearAnalisisRequestSchema: GenMessage<ParsearAnalisisRequest> = /*@__PURE__*/
  messageDesc(file_fertilizacion, 8);

/**
 * Lote que se asigna a mano a un registro del analisis.
 *
 * @generated from message sextante.fertilizacion.v1.AsignacionLoteItem
 */
export type AsignacionLoteItem = Message<"sextante.fertilizacion.v1.AsignacionLoteItem"> & {
  /**
   * @generated from field: string registro_id = 1;
   */
  registroId: string;

  /**
   * @generated from field: string lote_id = 2;
   */
  loteId: string;
};

/**
 * Describes the message sextante.fertilizacion.v1.AsignacionLoteItem.
 * Use `create(AsignacionLoteItemSchema)` to create a new message.
 */
export const AsignacionLoteItemSchema: GenMessage<AsignacionLoteItem> = /*@__PURE__*/
  messageDesc(file_fertilizacion, 9);

/**
 * asignaciones puede venir vacia (solo (re)genera la recomendacion sin reasignar nada) o parcial
 * (el cliente solo manda los registros cuyo lote cambio, ver AsignarLotesRequest.ts del cliente).
 *
 * @generated from message sextante.fertilizacion.v1.AsignarLotesRequest
 */
export type AsignarLotesRequest = Message<"sextante.fertilizacion.v1.AsignarLotesRequest"> & {
  /**
   * @generated from field: string analisis_id = 1;
   */
  analisisId: string;

  /**
   * @generated from field: repeated sextante.fertilizacion.v1.AsignacionLoteItem asignaciones = 2;
   */
  asignaciones: AsignacionLoteItem[];
};

/**
 * Describes the message sextante.fertilizacion.v1.AsignarLotesRequest.
 * Use `create(AsignarLotesRequestSchema)` to create a new message.
 */
export const AsignarLotesRequestSchema: GenMessage<AsignarLotesRequest> = /*@__PURE__*/
  messageDesc(file_fertilizacion, 10);

/**
 * Analisis a eliminar.
 *
 * @generated from message sextante.fertilizacion.v1.EliminarAnalisisRequest
 */
export type EliminarAnalisisRequest = Message<"sextante.fertilizacion.v1.EliminarAnalisisRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message sextante.fertilizacion.v1.EliminarAnalisisRequest.
 * Use `create(EliminarAnalisisRequestSchema)` to create a new message.
 */
export const EliminarAnalisisRequestSchema: GenMessage<EliminarAnalisisRequest> = /*@__PURE__*/
  messageDesc(file_fertilizacion, 11);

/**
 * Sin datos: que el rpc no falle ya indica que se elimino.
 *
 * @generated from message sextante.fertilizacion.v1.EliminarAnalisisResponse
 */
export type EliminarAnalisisResponse = Message<"sextante.fertilizacion.v1.EliminarAnalisisResponse"> & {
};

/**
 * Describes the message sextante.fertilizacion.v1.EliminarAnalisisResponse.
 * Use `create(EliminarAnalisisResponseSchema)` to create a new message.
 */
export const EliminarAnalisisResponseSchema: GenMessage<EliminarAnalisisResponse> = /*@__PURE__*/
  messageDesc(file_fertilizacion, 12);

/**
 * Analisis de laboratorio de suelo y foliares de la SPA Cliente, con la recomendacion de fertilizacion.
 * Logica propia del servicio gRPC, sin la capa vieja de servicios. Dos servicios externos hacen el trabajo
 * pesado: Lab Parser API lee el Excel del laboratorio y el microservicio de recomendacion arma el plan. En
 * la compilacion Nitrofert la recomendacion trae ademas grupos de lotes y lista de compra. Requiere sesion
 * de la app Cliente.
 * 
 * Nombres de mensaje con prefijo de dominio, no genericos: ver terceros_lote.proto para el gotcha
 * real que motivo esta regla (csharp_namespace compartido) — revisar que un nombre no exista ya en
 * otro .proto antes de usarlo (grep -rn "^message " Api/Protos/*.proto).
 * 
 * Pertenencia (2026-09-30): solo trabaja con datos de fincas del cliente de la sesion. Una finca, lote o
 * registro de otro cliente responde NotFound, igual que uno inexistente.
 *
 * @generated from service sextante.fertilizacion.v1.FertilizacionService
 */
export const FertilizacionService: GenService<{
  /**
   * Analisis de una finca, por delta.
   *
   * @generated from rpc sextante.fertilizacion.v1.FertilizacionService.ListByFincaId
   */
  listByFincaId: {
    methodKind: "unary";
    input: typeof ListAnalisisByFincaIdRequestSchema;
    output: typeof ListAnalisisByFincaIdResponseSchema;
  },
  /**
   * Crea un analisis a partir del Excel ya subido a Storage: lo descarga, lo manda a Lab Parser API y guarda
   * lo que devuelve. Intenta asociar cada registro a un lote por nombre.
   *
   * @generated from rpc sextante.fertilizacion.v1.FertilizacionService.Parsear
   */
  parsear: {
    methodKind: "unary";
    input: typeof ParsearAnalisisRequestSchema;
    output: typeof AnalisisLaboratorioItemSchema;
  },
  /**
   * Asigna lotes a mano a los registros que lo necesiten y vuelve a generar la recomendacion con el
   * microservicio externo. Todo o nada: si algo falla no guarda nada.
   *
   * @generated from rpc sextante.fertilizacion.v1.FertilizacionService.AsignarLotes
   */
  asignarLotes: {
    methodKind: "unary";
    input: typeof AsignarLotesRequestSchema;
    output: typeof AnalisisLaboratorioItemSchema;
  },
  /**
   * Elimina un analisis.
   *
   * @generated from rpc sextante.fertilizacion.v1.FertilizacionService.Eliminar
   */
  eliminar: {
    methodKind: "unary";
    input: typeof EliminarAnalisisRequestSchema;
    output: typeof EliminarAnalisisResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_fertilizacion, 0);

